import script from "./TopicTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./TopicTextEditor.vue?vue&type=style&index=0&id=190f9766&scoped=true&lang=css"
import "./TopicTextEditor.vue?vue&type=style&index=1&id=190f9766&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190f9766"]])

export default __exports__